<template>

  <div class="checkout-items">
    <b-card
      v-for="product in basketList"
      :key="product.id"
      class="ecommerce-card"
      no-body
    >

      <!-- Product Image -->
      <div class="item-img">
        <b-link>
          <b-img
            :src="product.item_id === 1 ? require(`@/assets/images/cards/${product.color === 1 ? 'cardBlack' : (product.color === 2 ? 'cardWhite' : 'cardMultiColor')}-Back.png`) : require(`@/assets/images/tags/${product.color === 1 ? 'tagBlack' : (product.color === 2 ? 'tagWhite' : 'tagMultiColor')}.png`)"
            rounded
            width="120vh"
          />
        </b-link>
      </div>

      <!-- Product Details: Card Body -->
      <b-card-body>
        <div class="item-name">
          <h6 class="mb-0">
            <b-link class="text-body">
              {{ product.item_id === 1 ? 'idy Card' : 'idy Tag' }}
            </b-link>
          </h6>
          <span class="item-company">{{ product.specifications.front_text }}</span>
        </div>
        <span class="text-success mb-1">Stokta Var</span>
      </b-card-body>

      <!-- Product Options/Actions -->
      <div class="item-options text-center">
        <div class="item-wrapper">
          <div class="item-cost">
            <h4 class="item-price">
              {{ Number(product.price).toLocaleString('tr-TR', {minimumFractionDigits: 2}) }}₺
            </h4>
          </div>
        </div>
        <b-button
          variant="light"
          class="mt-1 remove-wishlist"
          @click="removeItem(product)"
        >
          <feather-icon
            icon="XIcon"
            class="mr-50"
          />
          <span>Ürünü Sil</span>
        </b-button>
      </div>
    </b-card>
  </div>

</template>

<script>
import {
  BCard, BCardBody, BLink, BImg, BButton,
} from 'bootstrap-vue'
import { mapGetters, mapActions } from 'vuex'
import { formatDate } from '@core/utils/filter'

export default {
  components: {
    BCard, BCardBody, BLink, BImg, BButton,
  },
  computed: {
    ...mapGetters({
      basketList: 'eCommerce/getBasketList',
    }),
  },
  methods: {
    ...mapActions({
      deleteBasketItem: 'eCommerce/deleteBasketItem',
    }),
    frmtDate(date, prop) {
      return formatDate(date, prop)
    },
    removeItem(product) {
      this.deleteBasketItem(product.id)
    },
  },
}
</script>
